import React, { useState, useEffect, useMemo } from 'react'
import { ApolloProvider } from 'react-apollo'
import { ApolloProvider as ApolloHooksProvider } from '@apollo/react-hooks'
import { client as apolloClient } from './Layout'
import { useQuery } from '@apollo/react-hooks'
import DocumentsConfigProvider from './contexts/DocumentsConfigContext'
import SnackbarProvider from './contexts/SnackbarContext'
import { LoanProvider } from '../shared/LoanContext'
import { HelloSignProvider } from './contexts/HelloSignContext'
import Loader from '../common/Loader'
import Error from '../common/Error'
import Document from './document-renewed'
import DocumentsQuery from './queries/DocumentsQuery'
import DocumentQuery from './queries/DocumentQuery'
import useLoanEntities from './document-renewed/hooks/useLoanEntities'
import { BorrowerType } from './document-renewed/constants'

function ProviderWrapper(props) {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const menuItems = window.document
      .getElementById('admin_tabs')
      .querySelectorAll('[data-toggle]')

    const handleActive = () => setIsVisible(true)

    menuItems.forEach((menuItem) =>
      menuItem.addEventListener('click', handleActive)
    )

    return () =>
      menuItems.forEach((menuItem) =>
        menuItem.removeEventListener('click', handleActive)
      )
  }, [])

  if (!isVisible) return null

  return (
    <DocumentsConfigProvider {...props} preventMarkAsNotRequired>
      <ApolloHooksProvider client={apolloClient}>
        <ApolloProvider client={apolloClient}>
          <SnackbarProvider>
            <FetcherWrapper {...props} />
          </SnackbarProvider>
        </ApolloProvider>
      </ApolloHooksProvider>
    </DocumentsConfigProvider>
  )
}

function FetcherWrapper(props) {
  const { loanId, documentId } = props

  const {
    data: allDocsData,
    loading: allDocsLoading,
    error: allDocsError,
  } = useQuery(DocumentsQuery, {
    variables: {
      rid: loanId,
    },
  })

  const {
    data: docData,
    loading: docLoading,
    error: docError,
  } = useQuery(DocumentQuery, {
    variables: {
      rid: documentId,
    },
  })

  if (allDocsLoading || docLoading) return <Loader number={4} />

  if (allDocsError || docError) return <Error />

  const { loan, helloSign } = allDocsData
  const { document } = docData

  return (
    <LoanProvider value={loan}>
      <HelloSignProvider value={helloSign}>
        <DataHandlerWrapper {...props} loan={loan} document={document} />
      </HelloSignProvider>
    </LoanProvider>
  )
}

function DataHandlerWrapper({ document, loan, resourceType }) {
  const { rid: documentId } = document
  const { businesses, rid: loanId } = loan
  const { guarantors } = businesses[0]

  const entities = useLoanEntities()

  const entity = useMemo(() => {
    for (const entity of entities) {
      const document = entity.documents.find((doc) => doc.rid === documentId)
      if (document) return { document, entity }
    }

    return loan
  }, [entities, documentId])

  return (
    <Document
      loanId={loanId}
      guarantors={guarantors}
      document={document}
      entity={entity}
      resourceType={resourceType}
      entityId={entity.rid}
      isAffiliate={entity.borrowerType === BorrowerType.affiliate}
      resetClientStore={() => apolloClient.resetStore()}
    />
  )
}

export default ProviderWrapper
